import { Component, Input, OnInit } from "@angular/core";
import { finalize } from "rxjs/operators";
import { PivotalStoryService } from "../../models/integrations/pivotal-story.service";

@Component({
  selector: "ab-pivotal-integration",
  templateUrl: "./pivotal.component.html",
})
export class PivotalIntegrationComponent implements OnInit {
  @Input() public notice: any;

  public loading: boolean;
  public story: any;
  public creatingStory: boolean;
  public error: any;
  public removingStory: boolean;

  constructor(private pivotalStoryService: PivotalStoryService) {}

  public ngOnInit() {
    this.loading = true;

    return this.pivotalStoryService
      .get(this.notice)
      .pipe(
        finalize(() => {
          delete this.loading;
        }),
      )
      .subscribe((story: any) => {
        this.story = story;
      });
  }

  public createStory() {
    this.story = { notice: this.notice };

    this.creatingStory = true;
    return this.pivotalStoryService
      .create(this.story)
      .pipe(
        finalize(() => {
          delete this.creatingStory;
        }),
      )
      .subscribe((data: any) => {
        if (data.error) {
          this.error = data.error;
        }
      });
  }

  public removeStory() {
    this.story = { notice: this.notice };

    this.removingStory = true;
    return this.pivotalStoryService
      .destroy(this.story)
      .pipe(
        finalize(() => {
          delete this.removingStory;
        }),
      )
      .subscribe(() => {
        delete this.story;
      });
  }
}
